import "../../../../stylesheets/bingo";
import "../../../../stylesheets/templates/bingo/template-1";
import "../../../../stylesheets/accounts/base";
import "./index";
import "./products";
import "./inscriptions";

$(".bingo-ticket-pack").on("change", function (e) {
  let new_product_price =
    document.querySelectorAll(`[name="product_price['${this.value}']"`)[0]
      ?.value || "0";
  let devices = ["mobile", "desktop"];
  let new_price;
  for (var i = 0; i < devices.length; i++) {
    let device = devices[i];
    $(`#select-pack-${device}`)[0].value = this.value;
    $(`#product-quantity-${device}`).attr(
      "data-price",
      parseInt(new_product_price)
    );
    let quantity = $(`#product-quantity-${device}`)[0].value || 0;
    new_price = parseInt(new_product_price) * parseInt(quantity);
    let format_price = new Intl.NumberFormat("es-CL").format(new_price);
    $(`#total_amount_product_${device}`).text(format_price);
  }
  $("#donator_donation_transactions_attributes_0_amount")[0].value = new_price;
  $("#donator_donation_transactions_attributes_0_product_id")[0].value =
    this.value;
});
